import { memo, useMemo } from 'react';
import UniversalAssociationsSelectOptions from './UniversalAssociationsSelectOptions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIResultsMessage from 'UIComponents/results/UIResultsMessage';
import styled from 'styled-components';
import { List } from 'immutable';
import getLang from 'I18n/utils/getLang';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIResultsMessage = styled(UIResultsMessage).withConfig({
  displayName: "UniversalAssociationsSelectSearchResults__StyledUIResultsMessage",
  componentId: "sc-1sgz2bn-0"
})(["img{margin-bottom:16px;}"]);
const UniversalAssociationsSelectSearchResults = ({
  canEdit,
  emailRecipientsIds,
  engagementOrInteractionType,
  isSearching,
  onToggleSelectAssociation,
  readOnly,
  singularObjectName,
  searchResults,
  searchText,
  selectedObjectTypeId,
  shouldDisableLastAssociation
}) => {
  const renderedEmptyState = useMemo(() => {
    if (isSearching) {
      return /*#__PURE__*/_jsx(StyledUIResultsMessage, {
        className: "m-top-2 m-bottom-0",
        illustration: "empty-state-charts",
        illustrationProps: {
          width: 130
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "universalAssociationsSelect.noResultsFound"
        })
      });
    }

    // In German all nouns are capitalized regardless where there are in a sentence or phrase
    const properCasedObjectName = singularObjectName && getLang() === 'de' ? singularObjectName : singularObjectName && singularObjectName.toLowerCase();
    return /*#__PURE__*/_jsxs(StyledUIResultsMessage, {
      className: "m-top-2 m-bottom-0",
      illustration: "empty-state-charts",
      illustrationProps: {
        width: 130
      },
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: selectedObjectTypeId ? 'universalAssociationsSelect.searchResults.noResults.noRecordsFound' : 'universalAssociationsSelect.searchResults.noResults.noCurrentAssociations',
        options: {
          singularObjectName: properCasedObjectName
        }
      }), /*#__PURE__*/_jsx("br", {}), selectedObjectTypeId ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "universalAssociationsSelect.searchResults.noResults.searchToFind",
        options: {
          singularObjectName: properCasedObjectName
        }
      }) : null]
    });
  }, [isSearching, singularObjectName, selectedObjectTypeId]);
  const renderedAssociationOptions = useMemo(() => {
    if (!searchResults) {
      return List();
    }
    return searchResults.reduce((acc, associationRecord) => {
      return acc.concat( /*#__PURE__*/_jsx(UniversalAssociationsSelectOptions, {
        associationRecord: associationRecord,
        canEdit: canEdit,
        emailRecipientsIds: emailRecipientsIds,
        engagementOrInteractionType: engagementOrInteractionType,
        onToggleSelectAssociation: onToggleSelectAssociation,
        readOnly: readOnly,
        searchText: searchText,
        selectedObjectTypeId: selectedObjectTypeId,
        shouldDisableLastAssociation: shouldDisableLastAssociation
      }, `${associationRecord.get('pluralObjectName')}-associations-options`));
    }, List());
  }, [canEdit, emailRecipientsIds, engagementOrInteractionType, onToggleSelectAssociation, readOnly, searchResults, searchText, selectedObjectTypeId, shouldDisableLastAssociation]);

  // Ensures a UniversalAssociationRecord exists for all associations search
  // and that object-specific record is populated with options
  if (!searchResults || !searchResults.size || !searchResults.first().get('associationOptionRecords').size) {
    return renderedEmptyState;
  }
  return renderedAssociationOptions;
};
export default /*#__PURE__*/memo(UniversalAssociationsSelectSearchResults);

// for testing purposes
const UniversalAssociationsSelectSearchResultsWrapper = {
  default: () => UniversalAssociationsSelectSearchResults
};
export { UniversalAssociationsSelectSearchResultsWrapper };